import React, { useEffect, useState } from 'react';
import { Button, Chip, Menu, MenuItem, styled, Typography } from '@mui/material';
import { colors } from '../../styles/globalStyles';
import { ReactComponent as ArrowDown } from '../../images/arrow_down.svg';
import { ReactComponent as ArrowDownDark } from '../../images/arrowDarkLang.svg';
import { ReactComponent as EnFlag } from '../../images/enFlag.svg';
import { ReactComponent as DeFlag } from '../../images/deFlag.svg';
import { ReactComponent as RuFlag } from '../../images/ruFlag.svg';

const MyMenu = styled(Menu)({
    marginTop: 6,

    '& div.MuiPaper-root': {
        width: 200,
        height: 141,

        border: '1.5px solid #3B7AF6',
        borderRadius: 20,
        boxShadow: 'none',
    },

    // Chrome,Safari,Edge scrollbar styles
    '& ::-webkit-scrollbar': {
        width: 17,
    },

    '& ::-webkit-scrollbar-thumb': {
        borderRadius: 100,
        border: '7px solid transparent',
        backgroundClip: 'content-box',
        backgroundColor: colors.transparentMain,
    },

    '& ::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
        borderRadius: 100,
        margin: 10,
    },

    // Firefox scrollbar styles
    '& ul': {
        padding: 0,
    },
});

const TypographyDropdown = styled(Typography)({
    fontSize: 10,
    fontWeight: 700,
});

const IconWrapper = styled('div')({
    paddingRight: 10,
});

const MyMenuItem = styled(MenuItem)({
    padding: 10,
    justifyContent: 'start',
    gap: 10,

    '& svg': {
        width: 24,
        height: 24,
    },
});

const TypographyMenuItem = styled(Typography)({
    fontWeight: 700,
    fontSize: 10,
    lineHeight: '100%',
    color: colors.darkBlue,
});

const Dates = styled(Chip)({
    fontSize: 10,
    borderRadius: 6,
});

const MenuItemBottomBorder = styled('div')({
    margin: '0 auto',
    maxWidth: '83%',
    borderBottom: '1px solid rgba(59, 122, 246, 0.14)',
});

const flagIcons = {
    ru: RuFlag,
    en: EnFlag,
    de: DeFlag,
};

const Dropdown = ({
    options,
    variant,
    width,
    height,
    font,
    setSelectedOption,
    selected = 0,
    styles = {},
    startIcon: Icon,
    isDarkIcon = false,
    isLangDropdown = false,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(selected);
    const open = Boolean(anchorEl);

    React.useEffect(() => {
        setSelectedIndex(selected);
    }, [selected]);

    const handleDropdownButtonClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setAnchorEl(null);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (setSelectedOption) setSelectedOption(options[selectedIndex]);
    }, [selectedIndex]);

    const LangIcon = Icon ? Icon : flagIcons[options[selectedIndex]?.code?.toLowerCase()];

    return (
        <>
            <Button
                component="nav"
                variant={variant || 'dropdownBlue'}
                endIcon={isDarkIcon ? <ArrowDownDark /> : <ArrowDown />}
                onClick={handleDropdownButtonClick}
                sx={{ minWidth: width, height, ...styles }}
            >
                {(Icon || isLangDropdown) && (
                    <IconWrapper>
                        <LangIcon />
                    </IconWrapper>
                )}
                <TypographyDropdown style={font ? { fontSize: font } : null}>
                    {isLangDropdown ? options[selectedIndex].code.toUpperCase() : options[selectedIndex].name}
                </TypographyDropdown>
            </Button>
            <MyMenu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {options.map(({ name, interval, code }, index) => {
                    const DropdownIconLang = flagIcons[code];

                    return (
                        <div key={name}>
                            <MyMenuItem
                                selected={index === selectedIndex}
                                onClick={(event) => handleMenuItemClick(event, index)}
                            >
                                {isLangDropdown && <DropdownIconLang />}
                                <TypographyMenuItem style={font ? { fontSize: font } : null}>{name}</TypographyMenuItem>
                                {interval && <Dates label={interval} size="small" variant="lightBlue" />}
                            </MyMenuItem>
                            <MenuItemBottomBorder />
                        </div>
                    );
                })}
            </MyMenu>
        </>
    );
};

export default Dropdown;
